import React from 'react';
import "./HeaderFile.css";

const HeaderFile = () => {
    return (
        <div>
            <div className='head-container'>
                <ul className='header-list'>
                    <li><a href="#about-me" className='main-nav-link'>ABOUT</a></li>
                    <li><a href="#pursuits" className='main-nav-link'>PURSUITS</a></li>
                    <li><a href="#portfolio" className='main-nav-link'>PORTFOLIO</a></li>
                    <li><a href="#career" className='main-nav-link'>CAREER</a></li>
                    <li><a href="#contact" className='main-nav-link'>CONTACT</a></li>
                </ul>
                <div className='right-content'>
                    <a className='cup' href="https://www.buymeacoffee.com/PravinKanth"><div className='cup-pos'>
                        <svg stroke="currentColor" fill="currentColor" viewBox="0 0 640 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M192 384h192c53 0 96-43 96-96h32c70.6 0 128-57.4 128-128S582.6 32 512 32H120c-13.3 0-24 10.7-24 24v232c0 53 43 96 96 96zM512 96c35.3 0 64 28.7 64 64s-28.7 64-64 64h-32V96h32zm47.7 384H48.3c-47.6 0-61-64-36-64h583.3c25 0 11.8 64-35.9 64z"></path></svg>
                        <div id="container">
                            <div className="steam" id="steam1"> </div>
                            <div className="steam" id="steam2"> </div>
                            <div className="steam" id="steam3"> </div>
                            <div className="steam" id="steam4"> </div>
                        </div>
                    </div>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default HeaderFile;